import axios from "@/plugins/axios";

let url = "/api/console/popups";

export default {
    getPopups(data){
        return axios.get(url, data).then(result => result.data);
    },
    getPopup(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postPopup(data){
        return axios.post(url, data).then(result => result.data);
    },
    putPopup(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deletePopup(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
